import { render, staticRenderFns } from "./alert-modal.vue?vue&type=template&id=386b97d7"
import script from "./alert-modal.vue?vue&type=script&lang=js"
export * from "./alert-modal.vue?vue&type=script&lang=js"
import style0 from "./alert-modal.vue?vue&type=style&index=0&id=386b97d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports